module.exports = __webpack_public_path__ + "img/s6.e7c98662.png";